import { WORDMARK_PATH, WORDMARK_VIEWBOX } from "./paths";
import {
  INK_COLOR,
  TILE_COLOR,
  type BrandColor,
  type BrandVariant,
} from "./tokens";

// Aspect ratio baked in from WORDMARK_VIEWBOX (3488:814 ≈ 4.285:1).
// `size` sets the rendered height; the width scales to preserve the ratio.
const WORDMARK_RATIO = 3488 / 814;

export interface AdvaWordmarkProps {
  size?: number;
  color?: BrandColor;
  variant?: BrandVariant;
  className?: string;
  title?: string;
  "aria-label"?: string;
}

export function AdvaWordmark({
  size = 24,
  color = "dark",
  variant = "transparent",
  className,
  title,
  "aria-label": ariaLabel,
}: AdvaWordmarkProps) {
  const accessibleName = ariaLabel ?? title ?? "Adva wordmark";
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox={WORDMARK_VIEWBOX}
      width={Math.round(size * WORDMARK_RATIO)}
      height={size}
      fillRule="evenodd"
      role="img"
      aria-label={accessibleName}
      className={className}
    >
      {title ? <title>{title}</title> : null}
      {variant === "solid" ? (
        <rect width="3488" height="814" fill={TILE_COLOR[color]} />
      ) : null}
      <path d={WORDMARK_PATH} fill={INK_COLOR[color]} />
    </svg>
  );
}
